module.exports = __webpack_public_path__ + "img/qrcode-titok.f21cc312.png";